import React, { useMemo } from 'react'
import { Button, Icon, Tooltip } from 'antd'

import { AssignTree, PAssignTreeType } from 'src/types'
import { PropsTreeSelected } from 'src/views/Management/Administration/views/tree'
import images from 'src/config/images'

import * as CSS from './styles'

type Props = {
  addNode: (node: AssignTree) => void
  data: AssignTree
  isChild?: boolean
  setTreeSelected?: (treeSelected: PropsTreeSelected) => void
  type: PAssignTreeType
}

export enum NodeColor {
  'DEFAULT' = '#FFF',
  'DISABLED' = '#e8e8e8',
  'SELECTED' = '#bbe1fb'
}

const options = {
  TENANT: {
    alt: '',
    color: '#1D4384',
    edit: false,
    icon: images.icons.organization
  },
  USER: {
    alt: '',
    color: '#6793DE',
    edit: true,
    icon: images.icons.folder
  },
  ORGANIZATION: {
    alt: '',
    color: '#2C65C7',
    edit: true,
    icon: images.icons.organization
  },
  COST_CENTER: {
    alt: '',
    color: '#FF9400',
    edit: true,
    icon: images.icons.cipher
  },
  REASON: {
    alt: '',
    color: '#378f34',
    edit: true,
    icon: images.icons.cipher
  }
}

export function Nodes({
  addNode,
  data,
  isChild,
  setTreeSelected,
  type
}: Props) {
  const nodeDetails = useMemo(() => options[type], [type])
  
  return (
    <>
      <CSS.Flex
        isChild={isChild}
        onClick={e => {
          if (!data.disabled) {
            setTreeSelected({
              id: data.assign_tree_id,
              name: data.assign_tree_name,
              chained: data.chained,
              p_assign_tree_type: data.p_assign_tree_type
            })
          }
        }}
      >
        {isChild && <CSS.ContainerBox />}
        <CSS.ContainerFlex
          color={nodeDetails.color}
          backgroundColor={data.color}
          id={String(data.assign_tree_id)}
        >
          <CSS.WrapIcon>
            <img alt={nodeDetails.alt} src={nodeDetails.icon} />
          </CSS.WrapIcon>
          <Tooltip title={data.assign_tree_name}>
            <CSS.Title>{data.assign_tree_name}</CSS.Title>
          </Tooltip>
        </CSS.ContainerFlex>
        {!data.disabled && addNode && (
          <Button
            type="link"
            onClick={e => {
              e.stopPropagation()
              addNode(data)
            }}
          >
            <Icon type="plus" />
          </Button>
        )}
      </CSS.Flex>
    </>
  )
}
